import { html, render } from 'lit-html';

import { paginationI18n } from './pagination-i18n';

const COMPONENT_NAME = 'd-pagination-control-status';

export class PaginationControlStatus extends HTMLElement {
  #start?: number;
  #end?: number;
  #max?: number;

  static get observedAttributes() {
    return ['start', 'end', 'max'];
  }

  attributeChangedCallback() {
    this.#start = Number.parseInt(this.getAttribute('start') ?? '0');
    this.#end = Number.parseInt(this.getAttribute('end') ?? '0');
    this.#max = Number.parseInt(this.getAttribute('max') ?? '0');
    this.#render();
  }

  connectedCallback() {
    this.classList.add(COMPONENT_NAME);
    this.attributeChangedCallback();
    this.#render();
  }

  #render() {
    const text = paginationI18n(this, 'status', {
      rowStart: this.#start,
      rowEnd: this.#end,
      rowCount: this.#max,
    });
    render(html` <p name="${COMPONENT_NAME}">${text}</p> `, this);
  }
}

customElements.define(COMPONENT_NAME, PaginationControlStatus);
declare global {
  interface HTMLElementTagNameMap {
    [COMPONENT_NAME]: PaginationControlStatus;
  }
}
